import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { ArticuloDeposito } from "@/shared/types/deposito";

export async function getArticuloDepositos(id: string): Promise<ArticuloDeposito[]> {
    await sleep(500);
    const response = await api.get("articulos/" + id + "/stock");
    return response.data;
}

export function useGetArticuloDepositosQuery(id: string, queryConfig: QueryConfig<ArticuloDeposito[]> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getArticuloDepositos(id),
        queryKey: ["articulos", id, "depositos"],
    })
}

export interface GetArticuloDepositosQueryProps {
    id: string,
    queryConfig?: QueryConfig<ArticuloDeposito[]>,
    children?: (queryResult: QueryResult<ArticuloDeposito[]>) => ReactNode
}

export function GetArticuloDepositosQuery({
    id,
    children,
    queryConfig
}: GetArticuloDepositosQueryProps) {
    const queryResult = useGetArticuloDepositosQuery(id, queryConfig);
    return children && children(queryResult);
}
